import FileService from './FileService';

export default FileService;
